
const Footer = () => {
  return (
    <footer className="footer centered ict-dark-bg">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="footer-copyright-strip centered-inner white center padding-24">
              <p>
                &copy; {new Date().getFullYear()} Uganda School of ICT, All Rights
                Reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
